import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { Col, Container, Row } from 'react-bootstrap'
import { Box, InnerHeading, LazyImage, MainHeading, SpanStyled, SpanStyledB } from '../../ui/Elements'

import { useTranslation } from 'react-i18next'
import { ContactButton } from '../../ui/CustomElements'
import i18n from '../../Languages/INEXT'
import { Animate } from 'react-simple-animate'
import { PrimaryHeading } from '../../ui/Elements'
import { Certificate1, Certificate2, Certificate3, Certificate4, OurProjectBg, ProjImg1, ProjImg2, ProjImg3, ProjImg4, ProjImg5, ProjImg6, ProjImg7, ProjImg8 } from '../../ui/AllImages'
// import { Link } from 'react-router-dom'
const Certificates = () => {
    const { t } = useTranslation();
    const sectionRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);


    const handleDownload = () => {
        const link = document.createElement("a");
        // const target = document.createTag("target");
        link.href = "https://alasass.sa/السجل.pdf"; // path to your PDF
        link.download = "السجل.pdf"; // name when saved
        link.target = "_blank"
        link.click();
    };
    const handleDownload2 = () => {
        const link = document.createElement("a");
        // const target = document.createTag("target");
        link.href = "https://alasass.sa/المقاول.pdf"; // path to your PDF
        link.download = "المقاول.pdf"; // name when saved
        link.target = "_blank"
        link.click();
    };
    const handleDownload3 = () => {
        const link = document.createElement("a");
        // const target = document.createTag("target");
        link.href = "https://alasass.sa/شهادة التصنيف.pdf"; // path to your PDF
        link.download = "شهادة التصنيف.pdf"; // name when saved
        link.target = "_blank"
        link.click();
    };


    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                // When visible, set to true
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.disconnect(); // run animation once
                }
            },
            {
                threshold: 0.2, // 20% of section visible triggers the animation
            }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => observer.disconnect();
    }, []);
    
    const start = i18n.language === "ar"
    ? { clipPath: "inset(0 0 0 100%)" }   // Arabic → reveal right → left
    : { clipPath: "inset(0 100% 0 0)" };  // English → reveal left → right
    const end = { clipPath: "inset(0 0% 0 0)" };
    const start2 = { opacity: 0, transform: 'translateY(-20px)' };
    const end2 = { opacity: 1, transform: 'translateY(0)' };
    const start3 = { opacity: 0, transform: 'translateY(0px)' };
    const end3 = { opacity: 1, transform: 'translateY(0)' };
    return (
        <>
            <CertificatesmWapper className='container-fluid common-space transformFluid' id='certificates' ref={sectionRef}>
                <Container>
                    <Box className='servicesRow row mb-5'>
                        <Col md={12} className="servicesColMain">
                            <Row className=''>
                                <Col md={12}>
                                    <Box className='projDescRow row'>
                                        <Col md={12} lg={6} className="servicesDescCol servicesDescCol1">
                                            {/* <Box className='servicesDescCol1Content'> */}
                                            <Animate
                                                                                            play={isVisible}
                                                                                            duration={1.5}
                                                                                            // delay={-0.5}
                                                                                            
                                                                
                                                                                            start={start}
                                                                                            end={end}
                                                                                        >
                                                <PrimaryHeading className='main-heading mb-1 projH' color="var(--text)">
                                                    {t('certifiTitle')}
                                                </PrimaryHeading>
                                                </Animate>
                                            {/* </Box> */}
                                            
                                        </Col>
                                        <Col md={12} lg={6} className="servicesDescCol servicesDescCol2">
                                        <Animate
                                                                                                                    play={isVisible}
                                                                                                                    duration={1}
                                                                                                                    delay={.8}
                                                                                                                    start={start2}
                                                                                                                    end={end2}
                                                                                                                >
                                            <SpanStyled className='d-flex mb-4 projTxt' color="var(--text)" size="40px" >
                                                {t('certifiTxt')}
                                            </SpanStyled>
                                            </Animate>
                                        </Col>
                                    </Box>
                                </Col>
                            </Row>
                        </Col>
                        
                    </Box>
                    
                    <ProjWapper className='container-fluid projFluid'>
                        <Row>
                            <Col lg={3} xs={6} className='projColImg'>
                            <Animate
                                    play={isVisible}
                                    duration={1}
                                    delay={1.2}
                                    start={start3}
                                    end={end3}
                                >
                                <Box className='projImg cursor-pointeer' onClick={handleDownload}>
                                    <LazyImage src={Certificate1} />
                                </Box>
                                </Animate>
                            </Col>
                            <Col lg={3} xs={6} className='projColImg'>
                            <Animate
                                                                                                        play={isVisible}
                                                                                                        duration={1}
                                                                                                        delay={1.6}
                                                                                                        start={start3}
                                                                                                        end={end3}
                                                                                                    >
                                <Box className='projImg cursor-pointeer' onClick={handleDownload2}>
                                    <LazyImage src={Certificate2} />
                                </Box>
                                </Animate>
                            </Col>
                            <Col lg={3} xs={6} className='projColImg'>
                            <Animate
                                                                                                        play={isVisible}
                                                                                                        duration={1}
                                                                                                        delay={2}
                                                                                                        start={start3}
                                                                                                        end={end3}
                                                                                                    >
                                <Box className='projImg cursor-pointeer' onClick={handleDownload3}>
                                    <LazyImage src={Certificate3} />
                                </Box>
                                </Animate>
                            </Col>
                            <Col lg={3} xs={6} className='projColImg'>
                            <Animate
                                                                                                        play={isVisible}
                                                                                                        duration={1}
                                                                                                        delay={2.4}
                                                                                                        start={start3}
                                                                                                        end={end3}
                                                                                                    >
                                <Box className='projImg cursor-pointeer'>
                                    <LazyImage src={Certificate4} />
                                </Box>
                                </Animate>
                            </Col>
                            
                        </Row>
                    </ProjWapper>



                </Container>
            </CertificatesmWapper>
            
            
        </>
    )
}
const CertificatesmWapper = styled.section`
    padding-bottom: 150px;
    padding-top: 120px;
    /* background-image: url(${OurProjectBg});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center; */
    
    .projDescRow{
        align-items: center;
    }
    
    & > .container{
        .transformRow{
            margin-left: 0;
            margin-right: 0;
        }
        .transformColMain{
            position: relative;
            display: flex;
            align-items: center;
            height: 395px;
            padding-left: 650px;
            
            .transformContent{
                display: flex;
                width: 545px;
                flex-wrap: wrap;
                flex-direction: column;
                padding-left: 0;
                
            }
            .ceoImg{
                position: absolute;
                left: 130px;
                bottom: 0px;
            }
        }
        
    }
    .projH{
        text-align: left;
        padding-bottom: 20px;
        padding-right: 270px;
        margin-left: 0;
        margin-right: auto;
    }
    .projTxt{
        font-size: 20px;
        font-weight: var(--semiBold);
        text-align: right;
    }
    
    body.rtl &{
        .projH{
            text-align: right;
            padding-right: 0;
            margin-right: 0;
            margin-left: auto
        }
        .projTxt{
            font-size: 36px;
            font-family: var(--arSemiBold);
        }
        
        & > .container{
            /* .transformRow{
                margin-left: 0;
                margin-right: 0;
            } */
            .transformColMain{
                padding-left: calc(var(--bs-gutter-x) * .5);
                padding-right: 650px;
                
                .transformContent{
                    width: 545px;
                    /* padding-left: 0;
                    padding-right: 0; */
                    
                }
                .ceoImg{
                    position: absolute;
                    left: auto;
                    right: 130px;
                }
            }
            
        }
    }
    
    @media (max-width: 1399px) {
        
    }
    @media (max-width: 1299px) {
        & > .container{
            .transformColMain{
                padding-left: 550px;
                .transformContent{
                    /* width: 545px; */
                }
                .ceoImg{
                    left: 0;
                }
            }
            
        }
        body.rtl &{
            & > .container{
                .transformColMain{
                    padding-right: 550px;
                    
                    .ceoImg{
                        right: 0;
                    }
                }
                
            }
        }
        
    }
    @media (max-width: 1199px) {
        & > .container{
            .transformColMain{
                padding-left: 500px;
                .transformContent{
                    width: 450px;
                }
                .ceoImg{
                    left: 0;
                }
            }
            
        }
        body.rtl &{
            
        }
    }
    @media (max-width: 991px) {
        & > .container{
            .transformColMain{
                padding: 0;
                .transformContent{
                    width: 100%;
                    padding: 0px 20px 0 20px;
                }
                .ceoImg{
                    display: none;
                }
            }
            
        }
        .projH{
            font-size: 40px;
        }
        .projTxt{
            
            text-align: left;
        }
        .projColImg{
            margin-bottom: 20px;
        }
        body.rtl &{
            & > .container{
                .transformColMain{
                    padding: 0;
                    .transformContent{
                        width: 100%;
                        padding: 0px 20px 0 20px;
                    }
                    .ceoImg{
                        display: none;
                    }
                }
                
            }
            .projH{
                text-align: right;
                padding-right: 0;
                font-size: 60px;
            }
            .projTxt{
                text-align: right;
                font-size: 30px;
            }
        }
    }
    @media (max-width: 767px) {
        & > .container{
            .transformColMain{
                height: auto;
                padding-top: 50px !important;
                padding-bottom: 50px !important;
                .transformContent{
                    width: 100%;
                    padding-left: 5px;
                    padding-right: 5px;
                    .transformTxt{
                        font-size: 18px;
                    }
                }
                
            }
            
        }
        body.rtl &{
            & > .container{
                .transformColMain{
                    .transformContent{
                        padding-left: 5px;
                        padding-right: 5px;
                    }
                    
                }
                
            }
            .projH{
                font-size: 50px;
            }
        }
    }
    @media (max-width: 640px) {
       
    }
    @media (max-width: 575px) {
        
    }
    @media (max-width: 350px) {
        
    }
`

const ProjWapper = styled.section`
    
    .projImg{
        border: 1px solid var(--text);
        border-radius: 8px;
        padding: 16px;
        span{
            width: 100%;
            img{
                width: 100%;
            }
        }
    }
`

export default Certificates
